import React from 'react'
// libs
import styled from 'styled-components'
// hooks
import { useShowModal } from 'hooks'
// components
import { IconButton } from 'components/UI'
// constants
import { Modals } from 'constants/modals'
// static
import ScheduleReviewIconOrigin from 'src/icons/schedule-review.svg'
// themes
import colors from 'themes/colors'
// utils
import { size } from 'polished'

const ScheduleReviewIcon = styled(ScheduleReviewIconOrigin)`
  && {
    ${size('20px')};

    path {
      fill: ${colors.white};
    }
  }
`

const ScheduleFormButton: React.FC = () => {
  const { showModal } = useShowModal({ modalType: Modals.RISK_RECURRENCE_MODAL })

  const showRecurrenceSettings = () => showModal()

  return (
    <IconButton onClick={showRecurrenceSettings} description='Recurrence Settings'>
      <ScheduleReviewIcon />
    </IconButton>
  )
}

export default ScheduleFormButton
